import React from "react";

/**
 * Official Big Dick's Undergear logo.
 * Uses the brand's stored image asset.
 */
export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_create-from-pic/artifacts/7cw9fvsh_new%20logo.png";

/**
 * Just the mascot crop (used in small circular contexts).
 * We use the same image but object-position/scale to show the mascot area.
 */
export default function BDLogo({ size = 96, className = "", variant = "mascot" }) {
  // "full" = full logo including wordmark
  // "mascot" = zoomed to the muscular mascot area (top of the image)
  const objectPosition = variant === "full" ? "center" : "center top";
  const objectFit = "cover";
  const aspect = variant === "full" ? { width: size, height: Math.round(size * 1.3) } : { width: size, height: size };

  return (
    <img
      src={LOGO_URL}
      alt="Big Dick's Undergear"
      width={aspect.width}
      height={aspect.height}
      className={className}
      style={{
        objectFit,
        objectPosition,
        display: "block",
      }}
      loading="lazy"
    />
  );
}
